import { REACT_TITLE } from "config/env";

export function getIsZenPilatesApp() {
    return REACT_TITLE === "PodoUP! [Zen Pilates]";
}
